<template>
  <v-container
    id="usuarioprodutor"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <div v-if="cadastrook">
              <div class="text-center grey--text text-h1 font-weight-light">
                {{ minutes }}:{{ seconds }}
              </div>
              <div class="text-center grey--text text-h4 font-weight-light">
                Você receberá um SMS no celular:
              </div>
              <div class="text-center text-h4 font-weight-black">
                {{ produtor.telefone }}
              </div>
              <!-- <div
                v-if="produtor.email !== ''"
                class="text-center grey--text text-h4 font-weight-light"
              >
                e uma mensagem no e-mail:
              </div>
              <div class="text-center text-h4 font-weight-black">
                {{ produtor.email }}
              </div> -->
              <div class="text-center grey--text text-h4 font-weight-light">
                com o código de confirmação.
              </div>
              <pages-heading class="text-center text-h4 pt-2">
                Confirme o seu cadastro inserindo o código no campo abaixo.
              </pages-heading>
              <v-text-field
                v-model="produtor.codigoativacao"
                :error-messages="errors"
                color="secondary"
                label="Código de Confirmação..."
                type="number"
                prepend-icon="mdi-lock-outline"
              />
              <v-row justify="center">
                <v-col
                  v-if="exibeReenviarCodigo"
                  cols="12"
                  lg="12"
                >
                  <v-checkbox
                    v-model="produtor.whatsapp"
                    label="Reenviar código por whatsapp?"
                    required
                  />
                  <v-btn
                    class="v-btn--block"
                    color="blue"
                    @click="reenviarCodigo()"
                  >
                    Reenviar Código
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  lg="5"
                >
                  <v-btn
                    class="v-btn--block"
                    color="success"
                    @click="ativar"
                  >
                    Confirmar
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <pages-heading class="text-center text-h2">
                Registrar Produtor
              </pages-heading>
              <validation-observer v-slot="{ invalid }">
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="salvar"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <div class="my-2" />

                      <tex-field-with-validation
                        v-model="produtor.nome"
                        class="inputText"
                        rules="required|regex:^([a-zA-Z0-9 ]+)$"
                        required
                        type="text"
                        label="Nome (sem acentos)..."
                        prepend-icon="mdi-card-account-details"
                      />

                      <tex-field-with-validation
                        v-model="produtor.cpf"
                        v-mask="maskcpf"
                        rules="required|regex:\d{3}\.\d{3}\.\d{3}-\d{2}"
                        required
                        type="tel"
                        label="CPF..."
                        prepend-icon="mdi-account-box-outline"
                      />
                      <!-- <tex-field-with-validation
                        v-model="produtor.email"
                        rules="regex:.+@.+\..+"
                        required
                        type="email"
                        label="Email..."
                        prepend-icon="mdi-email-outline"
                      /> -->

                      <tex-field-with-validation
                        v-model="produtor.telefone"
                        v-mask="maskphone"
                        rules="required|regex:\([0-9]{2}\)9[0-9]{4}-[0-9]{4}"
                        required
                        type="tel"
                        label="Telefone..."
                        prepend-icon="mdi-phone-outline"
                      />
                      <v-row>
                        <v-col
                          cols="1"
                        >
                          <v-icon>mdi-calendar-check-outline</v-icon>
                        </v-col>
                        <v-col cols="3">
                          <v-select
                            v-model="selectedDay"
                            :items="dayOptions"
                            :success="true"
                            label="Dia"
                            @change="updateDate"
                            v-on="on"
                          />
                        </v-col>
                        <v-col cols="4">
                          <v-select
                            v-model="selectedMonth"
                            :items="monthOptions"
                            :success="true"
                            label="Mês"
                            @change="updateDate"
                            v-on="on"
                          />
                        </v-col>
                        <v-col cols="4">
                          <v-select
                            v-model="year"
                            :items="yearOptions"
                            :success="true"
                            label="Ano"
                            @change="updateDate"
                            v-on="on"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-checkbox
                      v-model="politica_privacidade"
                      :rules="[v => !!v || 'Você deve concordar para continuar!']"
                      required
                    >
                      <template v-slot:label>
                        <div>
                          Eu li e concordo com os Termos da
                          <a
                            href="#"
                            @click.stop
                          >
                            Política de Privacidade.
                          </a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="6"
                    >
                      <div
                        v-if="exibeProgress"
                        class="text-center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        />
                      </div>
                      <v-btn
                        v-else
                        class="v-btn--block"
                        :disabled="!valid || invalid"
                        color="success"
                        default
                        min-width="180"
                        type="submit"
                      >
                        Registrar
                      </v-btn>
                      <!-- <div
                        id="ios-div"
                        class="text-center mt-3"
                      >
                        <p>
                          <router-link to="/login">
                            Login de demonstração
                          </router-link>
                        </p>
                      </div> -->
                    </v-col>
                  </v-row>
                  <base-material-snackbar
                    v-model="snackbar.visible"
                    :timeout="snackbar.timeout"
                    :top="true"
                    :type="snackbar.color"
                  >
                    {{ snackbar.message }}
                  </base-material-snackbar>
                </v-form>
              </validation-observer>
            </div>
            <div class="mt-2 text-center grey--text text-h4 font-weight-light">
              Quer ajuda para fazer o seu cadastro? Assista o vídeo abaixo:
            </div>
            <v-skeleton-loader
              v-if="loading"
              height="250"
              type="card"
            />
            <youtube-embed
              v-else
              :video-id="'6vzJS-x0bGU'"
            />
            <pages-heading
              v-if="exibeBotaoRemover"
              class="text-center text-h4 pt-2"
            >
              Se seu telefone ou cpf estiver incorretos, remova o cadastro usando o botão abaixo.
            </pages-heading>
            <v-btn
              v-if="exibeBotaoRemover"
              class="v-btn--block"
              color="error"
              default
              min-width="180"
              @click="showDialog('Antes de remover o cadastro tente reenviar o codigo. Tem certeza que deseja remover o cadastro?'), exibeBotao()"
            >
              remover cadastro
            </v-btn>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog.visible"
      max-width="411"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          {{ dialog.message }}
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-btn
            class="mr-3"
            text
            @click="dialog.visible = false"
          >
            Não
          </v-btn>

          <v-btn
            color="success"
            text
            @click="desativar(), dialog.visible = false"
          >
            Sim
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import UsuarioProdutor from '../../services/usuarioprodutor'
  import YoutubeEmbed from '../../components/base/YoutubeEmbed'
  import utils from '../../services/utils'
  export default {

    name: 'PagesUsuarioProdutor',

    components: {
      // PagesBtn: () => import('./components/Btn'),
      PagesHeading: () => import('./components/Heading'),
      YoutubeEmbed,
    },
    mixins: [utils],

    data: () => ({
      on: null,
      selectedDay: '01',
      selectedMonth: '01',
      year: new Date().getFullYear().toString(),
      valid: false,
      invalid: true,
      timeoutHandle: null,
      exibeReenviarCodigo: false,
      exibeBotaoRemover: false,
      exibeProgress: false,
      produtor: {
        id: '',
        chaveativacao: '',
        nome: '',
        // email: '',
        cpf: '',
        telefone: '',
        datanascimento: '',
        codigoativacao: '',
        platform: '',
        osname: 'unknown',
        token: '',
        whatsapp: false,
      },
      cadastrook: false,
      errors: [],
      // codigoativacaotemp: '',
      maskcpf: '###.###.###-##',
      maskphone: '(##)#####-####',
      nomeRules: [
        v => !!v || 'O nome é obrigatório',
      ],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: '',
        timeout: 3000,
      },
      dialog: {
        visible: false,
        message: '',
      },
      countDown: 0,
      minutes: 4,
      seconds: '00',
      politica_privacidade: false,
      loading: false,
      msgEnvio: '',
      items: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
      isDev: process.env.NODE_ENV === 'development',
    }),
    computed: {
      dayOptions () {
        const daysInMonth = this.getDaysInMonth(parseInt(this.selectedMonth), this.year)
        return Array.from({ length: daysInMonth }, (_, index) =>
          String(index + 1).padStart(2, '0'),
        )
      },
      monthOptions () {
        return Array.from({ length: 12 }, (_, index) => String(index + 1).padStart(2, '0'))
      },
      yearOptions () {
        const currentYear = new Date().getFullYear()
        return Array.from({ length: 101 }, (_, index) => String(currentYear - index))
      },
    },
    // watch: {
    //   nome (novoCodigo) {
    //     localStorage.chaveativacao = novoCodigo
    //   },
    // },

    mounted () {
      this.valid = false
      this.invalid = true

      const iosDiv = document.getElementById('ios-div')
      if (iosDiv) {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && this.isDev) {
          iosDiv.style.display = 'block'
        } else {
          iosDiv.style.display = 'none'
        }
      } else {
        console.warn("Elemento 'ios-div' não encontrado.")
      }

      if (localStorage.getItem('cadastrook')) {
        this.cadastrook = localStorage.getItem('cadastrook') === 'true'
        if (this.cadastrook) {
          this.reiniciaContador()
        }
      }

      if (localStorage.getItem('chaveativacao')) {
        this.loading = true
        UsuarioProdutor.verificaAcessoUsuario(localStorage.chaveativacao)
          .then(resposta => {
            if (resposta.data.status === 'ativo') {
              this.$router.push('/')
            }
            this.loading = false
            this.verificaVersao(resposta.data.versao_vue)
          })
          .catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.response.data.errors) {
              this.errors = e.response.data.errors
            } else if (e.response.data.status) {
              this.showSnackbar('error', 3000, e.response.data.status + ' - Erro ao registrar')
            } else {
              this.showSnackbar('error', 3000, 'Ocorreu um erro ao registrar')
            }
            this.loading = false
          })
        this.produtor.chaveativacao = localStorage.chaveativacao
        this.carregaDadosOffline()
      } else {
        this.limpaDadosOffline()
        this.carregaDadosOffline()
      }
      this.carregaInfoSistemaOperacional()
      this.carregaMsgEnvio()
    },

    methods: {
      updateDate () {
        this.menuData = false
        this.data = `${this.year}-${this.selectedMonth}-${this.selectedDay}`
        this.produtor.datanascimento = this.data
      },
      getDaysInMonth (month, year) {
        return new Date(year, month, 0).getDate()
      },
      salvar () {
        this.exibeProgress = true
        this.msgEnvio = ''
        this.produtor.osname = localStorage.osname
        if (localStorage.token && localStorage.token !== '') {
          this.produtor.token = localStorage.token
        }
        if (localStorage.platform && localStorage.platform !== '') {
          this.produtor.platform = localStorage.platform
        } else {
          this.produtor.platform = 'unknown'
        }
        // console.log(this.produtor.platform)
        this.loading = true
        if (this.$refs.form.validate()) {
          UsuarioProdutor.salvar(this.produtor).then(resposta => {
            this.reiniciaContador()
            this.errors = ''
            this.produtor.chaveativacao = resposta.data.chaveativacao
            // this.codigoativacaotemp = resposta.data.codigoativacao
            this.cadastrook = true
            localStorage.chaveativacao = this.produtor.chaveativacao
            this.salvaDadosOffline()
            this.loading = false
            this.carregaMsgEnvio()
            this.cadastrook = true
            localStorage.setItem('cadastrook', true)
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            } else if (e.response.data.errors) {
              this.errors = e.response.data.errors
            } else if (e.response.data.status) {
              // erro não tratado
              this.showSnackbar('error', 3000, e.response.data.status + ' - Erro ao registrar')
            } else {
              this.showSnackbar('error', 3000, ' Ocorreu um erro ao registrar')
            }
          }).finally(f => { this.exibeProgress = false })
        }
      },

      carregaMsgEnvio () {
        if (localStorage.telefone) {
          this.produtor.telefone = localStorage.telefone
        }
        if (localStorage.email && localStorage.email.length > 0) {
          this.produtor.email = localStorage.email
        }
      },

      ativar () {
        this.errors = ''
        UsuarioProdutor.ativar(this.produtor).then(resposta => {
          this.errors = ''
          if (resposta.data.ativo === true) {
            this.$router.push('/')
            localStorage.countDownViewMenu = 0
          } else if (resposta.data.status === 'remover') {
            this.cadastrook = false
            this.limpaDadosOffline()
            console.info('remover...')
          }
        }).catch(e => {
          // console.log(e.data)
          this.errors = e.data.errors[0]
        })
      },

      desativar () {
        if (localStorage.chaveativacao) {
          UsuarioProdutor.desativar(localStorage.chaveativacao).then(resposta => {
            this.errors = ''
          }).catch(e => {
            this.errors = e.response.data.errors
          })
        }
        this.limpaDadosOffline()
      },

      reenviarCodigo () {
        this.cadastrook = true
        localStorage.setItem('cadastrook', true)
        this.exibeReenviarCodigo = false
        this.exibeBotaoRemover = false
        // reinicia contador
        this.reiniciaContador()
        // reenvia codigo de ativacao
        if (localStorage.chaveativacao) {
          UsuarioProdutor.reenviaCodigoAtivacao(localStorage.chaveativacao, this.produtor.whatsapp).then(resposta => {
            // esconde botao
            this.exibeReenviarCodigo = false
            this.exibeBotaoRemover = false
          }).catch(e => {
            this.errors = e.response.data.errors
            // this.limpaDadosOffline()
            this.exibeReenviarCodigo = true
            this.exibeBotaoRemover = true
          })
        } else {
          this.limpaDadosOffline()
        }
      },

      reiniciaContador () {
        this.countDown = 0
        this.minutes = 2
        this.seconds = '00'
        clearTimeout(this.timeoutHandle)
        this.countDownTimer()
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },
      exibeBotao () {
        this.exibeBotaoRemover = false
        this.exibeReenviarCodigo = false
        this.reiniciaContador()
      },
      countDownTimer () {
        if (this.minutes >= 0) {
          this.timeoutHandle = setTimeout(() => {
            if (this.countDown === 0 && this.minutes > 0) {
              this.countDown = 60
              this.minutes -= 1
            }
            if (this.countDown > 0) {
              this.countDown -= 1
              if (this.countDown < 10) {
                this.seconds = '0' + this.countDown
              } else {
                this.seconds = this.countDown
              }
              this.countDownTimer()
            } else {
              this.exibeReenviarCodigo = true
              this.exibeBotaoRemover = true
            }
          }, 1000)
        }
      },
      limpaDadosOffline () {
        localStorage.removeItem('chaveativacao')
        // localStorage.removeItem('codigoativacaotemp')
        localStorage.setItem('cadastrook', false)
        this.cadastrook = false
      },
      salvaDadosOffline () {
        // Dados do Produtor =========================================v
        localStorage.nome = this.produtor.nome
        localStorage.cpf = this.produtor.cpf
        localStorage.telefone = this.produtor.telefone
        localStorage.email = this.produtor.email
        localStorage.datanascimento = this.produtor.datanascimento
        // Dados do Produtor =========================================^
      },
      carregaDadosOffline () {
        // Dados do Produtor Offline =========================================v
        if (localStorage.nome) {
          this.produtor.nome = localStorage.nome
        }

        if (localStorage.cpf) {
          this.produtor.cpf = localStorage.cpf
        }

        if (localStorage.telefone) {
          this.produtor.telefone = localStorage.telefone
        }

        if (localStorage.email) {
          this.produtor.email = localStorage.email
        }

        if (localStorage.datanascimento) {
          this.produtor.datanascimento = localStorage.datanascimento
        }
        if (localStorage.cadastrook) {
          this.cadastrook = (localStorage.cadastrook === 'true')
        }
        // Dados do Produtor Offline =========================================^
      },
    },
  }
</script>

<style lang="sass">
.v-text-field input
  font-size: 1.2em

.input-20
  font-size: 48dp

#register
  .v-list-item__subtitle
    -webkic-line-clamp: initial
    -webkit-box-orient: initial

.theme--light.v-input:not(.v-input--is-disabled) input
  font-size: 15px
  width: 20px
  left: 50px
  color: #495057

</style>

<style scoped>
.video-container {
    overflow: hidden;
    position: relative;
    width:100%;
}

.video-container::after {
    padding-top: 56.25%;
    display: block;
    content: '';
}

.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
#inputText{
  font-size: 48dp
}
/* .theme--light.v-input:not(.v-input--is-disabled) input{
  font-size: 21px;
  font-weight: 400;
  color: #495057;
} */
</style>
